interface Key {
  prefix: string;
  suffix: string;
}

export class Storage {
  private key: Key = { prefix: '', suffix: '' };

  load(key: Key, value?: string) {
    this.key = key;

    if (value) {
      this.set(value);
    }

    return this.get();
  }

  private getKey(): string {
    return `${this.key.prefix}_${this.key.suffix}`;
  }

  private remove(key: string): void {
    window.localStorage.removeItem(key);
  }

  private removeOldEntries(): void {
    const keys = Object.keys(window.localStorage);

    for (const key of keys) {
      if (key.startsWith(this.key.prefix) && key !== this.getKey()) {
        this.remove(key);
      }
    }
  }

  private set(value: string): void {
    const existingValue = this.get();

    if (existingValue) {
      return;
    }

    // Deletes old entries from the storage while keeping the current one
    // This is to avoid filling the browser storage and running into the quota limit
    this.removeOldEntries();

    try {
      window.localStorage.setItem(this.getKey(), value);
    } catch (err) {
      console.error(err);
    }
  }

  get(): string | null {
    return window.localStorage.getItem(this.getKey());
  }
}
